import { useInfiniteQuery } from 'react-query'

import { fetchPostEventsCreatedByUserId } from 'utils/queries'

import { Event } from 'types/event'

export const useUserCreatedEvents = ({ userId }: { userId: string | null | undefined }) => {
  return useInfiniteQuery<Array<Event>>(
    ['userCreatedEvents', [userId]],
    ({ pageParam }) =>
      fetchPostEventsCreatedByUserId(userId, {
        order: 'created',
        orderDirection: 'desc',
        lastVisible: pageParam,
        limit: 10,
      }),
    {
      // refetchOnMount: 'always',
      // refetchOnWindowFocus: 'always',
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1].created
      },
    },
  )
}
